import React from 'react';
import { ReferenceArrayInput, useQuery, Loading } from 'react-admin';
import { Grid } from '@material-ui/core/';
import { find } from 'lodash';

import GridInputFilter from '../../../core/components/inputs/GridInputFilter';
import { makeStyles } from '@material-ui/core';

const validateInvestors = (value, allValues, props, field) => {
  if (Array.isArray(value) && value.length < 1) {
    return 'At least one Investor must be selected';
  }
  if (Array.isArray(value) && value.length > 50) {
    return 'You cannot select more than 50 Investors.';
  }
  return undefined;
};

const useStyles = makeStyles({
  loading: {
    height: 'calc(100vh - 230px)'
  }
});

const InvestorDatagrid = props => {
  const classes = useStyles();
  let { data, loading } = useQuery({
    type: 'getManyReference',
    resource: 'fundinvestors',
    payload: {
      target: 'investorId',
      id: props.investorId,
      sort: {
        order: 'ASC'
      }
    }
  });
  if (loading) return <Loading className={classes.loading} />;
  const filter = choices => {
    return choices.filter(
      item => find(data, ['investorId', item.id]) === undefined
    );
  };

  const ReferenceArrayInputProps = {
    label:
      'To copy Contacts to Investors, select one or multiple items from the list of the investors below.',
    optionTextLabel: 'Investor Name',
    optionValueLabel: 'Investor ID',
    resource: 'investors',
    reference: 'investors',
    source: 'investors'
  };

  return (
    <div>
      <Grid container spacing={1}>
        <ReferenceArrayInput
          perPage={-1}
          sort={{ field: 'name', order: 'ASC' }}
          validate={[validateInvestors]}
          {...ReferenceArrayInputProps}
        >
          <GridInputFilter
            choicesToExclude={data}
            filterOptionValue="investorId"
            filter={filter}
            height={'calc(100vh - 335px)'}
          />
        </ReferenceArrayInput>
      </Grid>
    </div>
  );
};

export default InvestorDatagrid;
